import React from "react";
import {
  Box,
  MobileStepper,
  Paper,
  Stack,
  Typography,
  Button,
  ArrowRightIcon,
  ArrowLeftIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const steps = [
  {
    label: "Select campaign settings",
    description: `For each ad campaign that you create, you can control how much
              you're willing to spend on clicks and conversions, which networks
              and geographical locations you want your ads to show on, and more.`,
  },
  {
    label: "Create an ad group",
    description:
      "An ad group contains one or more ads which target a shared set of keywords.",
  },
  {
    label: "Create an ad",
    description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
  },
];

const TextStepper = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = steps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Vertical stepper
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          Vertical steppers are designed for narrow screen sizes. They are ideal
          for mobile. All the features of the horizontal stepper can be
          implemented.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "" +
              "  const steps = [\n" +
              "    {\n" +
              '      label: "Select campaign settings",\n' +
              "      description: `For each ad campaign that you create, you can control how much\n" +
              "              you're willing to spend on clicks and conversions, which networks\n" +
              "              and geographical locations you want your ads to show on, and more.`,\n" +
              "    },\n" +
              "    {\n" +
              '      label: "Create an ad group",\n' +
              "      description:\n" +
              '          "An ad group contains one or more ads which target a shared set of keywords.",\n' +
              "    },\n" +
              "    {\n" +
              '      label: "Create an ad",\n' +
              "      description: `Try out different ad text to see what brings in the most customers,\n" +
              "              and learn how to enhance your ads using features like ad extensions.\n" +
              "              If you run into any problems with your ads, find out how to tell if\n" +
              "              they're running and how to resolve approval issues.`,\n" +
              "    },\n" +
              "  ];\n" +
              "  \n" +
              "  \n" +
              "  const [activeStep, setActiveStep] = React.useState(0);\n" +
              "  const maxSteps = steps.length;\n" +
              "\n" +
              "  const handleNext = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep + 1);\n" +
              "  };\n" +
              "\n" +
              "  const handleBack = () => {\n" +
              "    setActiveStep((prevActiveStep) => prevActiveStep - 1);\n" +
              "  };\n" +
              "" +
              "              <Paper\n" +
              "                square\n" +
              "                elevation={0}\n" +
              "                sx={{\n" +
              '                  display: "flex",\n' +
              '                  alignItems: "center",\n' +
              "                  height: 50,\n" +
              "                  pl: 2,\n" +
              '                  bgcolor: "background.default",\n' +
              "                }}\n" +
              "              >\n" +
              "                <Typography>{steps[activeStep].label}</Typography>\n" +
              "              </Paper>\n" +
              '              <Box sx={{ height: 255, maxWidth: 400, width: "100%", p: 2 }}>\n' +
              "                {steps[activeStep].description}\n" +
              "              </Box>\n" +
              "              <MobileStepper\n" +
              '                variant="text"\n' +
              "                steps={maxSteps}\n" +
              '                position="static"\n' +
              "                activeStep={activeStep}\n" +
              "                nextButton={\n" +
              "                  <>\n" +
              "                    <Button\n" +
              '                      size="small"\n' +
              '                      variant={"text"}\n' +
              "                      disabled={activeStep === maxSteps - 1}\n" +
              "                      onClick={handleNext}\n" +
              "                      endIcon={<KeyboardArrowRight />}\n" +
              "                    >\n" +
              "                      NEXT\n" +
              '                      {/* {theme.direction === "rtl" ? (\n' +
              "                        <KeyboardArrowLeft />\n" +
              "                      ) : (\n" +
              "                        <KeyboardArrowRight />\n" +
              "                      )} */}\n" +
              "                    </Button>\n" +
              "                  </>\n" +
              "                }\n" +
              "                backButton={\n" +
              "                  <>\n" +
              "                    <Button\n" +
              '                      size="small"\n' +
              '                      variant={"text"}\n' +
              "                      startIcon={<KeyboardArrowLeft />}\n" +
              "                      onClick={handleBack}\n" +
              "                      disabled={activeStep === 0}\n" +
              "                    >\n" +
              '                      {/* {theme.direction === "rtl" ? (\n' +
              "                        <KeyboardArrowRight />\n" +
              "                      ) : (\n" +
              "                        <KeyboardArrowLeft />\n" +
              "                      )} */}\n" +
              "                      Back\n" +
              "                    </Button>\n" +
              "                  </>\n" +
              "                }\n" +
              "              />"
            }
          >
            <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
              <Paper
                square
                elevation={0}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: 50,
                  pl: 2,
                  bgcolor: "background.default",
                }}
              >
                <Typography>{steps[activeStep].label}</Typography>
              </Paper>
              <Box sx={{ height: 255, maxWidth: 400, width: "100%", p: 2 }}>
                {steps[activeStep].description}
              </Box>
              <MobileStepper
                variant="text"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <>
                    <Button
                      size="small"
                      variant={"text"}
                      disabled={activeStep === maxSteps - 1}
                      onClick={handleNext}
                      endIcon={<ArrowRightIcon />}
                    >
                      NEXT
                      {/* {theme.direction === "rtl" ? (
                        <KeyboardArrowLeft />
                      ) : (
                        <KeyboardArrowRight />
                      )} */}
                    </Button>
                  </>
                }
                backButton={
                  <>
                    <Button
                      size="small"
                      variant={"text"}
                      startIcon={<ArrowLeftIcon />}
                      onClick={handleBack}
                      disabled={activeStep === 0}
                    >
                      {/* {theme.direction === "rtl" ? (
                        <KeyboardArrowRight />
                      ) : (
                        <KeyboardArrowLeft />
                      )} */}
                      Back
                    </Button>
                  </>
                }
              />
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default TextStepper;
